import { render, staticRenderFns } from "./reviewer-reports-page.component.vue?vue&type=template&id=56645fc2"
import script from "./reviewer-reports-page.component.ts?vue&type=script&lang=ts&external"
export * from "./reviewer-reports-page.component.ts?vue&type=script&lang=ts&external"
import style0 from "./reviewer-reports-page.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports